import { render, staticRenderFns } from "./pointChart1.vue?vue&type=template&id=1d6cb5f2&scoped=true"
import script from "./pointChart1.vue?vue&type=script&lang=js"
export * from "./pointChart1.vue?vue&type=script&lang=js"
import style0 from "./pointChart1.vue?vue&type=style&index=0&id=1d6cb5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6cb5f2",
  null
  
)

export default component.exports